//* 장례식장 추가정보 편집용 순수 변환 — 컴포넌트(axios·antd) 없이 테스트할 수 있게 분리
import {
  FuneralHomeAdditionalInfo,
  FuneralHomeInfo,
} from '@shared/api/funeralHomeInfo/funeralHomeInfo.interface';
import { Image as ImageType } from '@shared/api/media/media.interface';

export type AdditionalInfoDraft = {
  //* 렌더 key — 서브도큐먼트 _id가 없는 신규 항목도 흔들리지 않게 별도로 둔다
  key: string;
  _id?: string;
  name: string;
  description: string;
  image?: { _id: string; url: string };
};

let draftKeySeq = 0;
export const nextDraftKey = () => {
  draftKeySeq += 1;
  return `additionalInfoDraft-${draftKeySeq}`;
};

//* image는 객체 · 문자열 id(populate 없음) · null(원본 삭제) 세 가지가 온다.
//* 앞의 둘은 사진 없음으로 취급한다 — `!image`를 빼면 null에서 터진다(typeof null === 'object').
const toDraftImage = (image?: unknown): AdditionalInfoDraft['image'] => {
  if (!image || typeof image === 'string') return undefined;
  const { _id, url } = image as ImageType;
  if (!_id || !url) return undefined;
  return { _id, url };
};

export const toAdditionalInfoDrafts = (
  funeralHomeInfo: Pick<
    FuneralHomeInfo<undefined, ImageType | string>,
    'additionalInfos'
  >,
): AdditionalInfoDraft[] =>
  (funeralHomeInfo.additionalInfos ?? []).map((item) => ({
    key: nextDraftKey(),
    _id: item._id,
    name: item.name ?? '',
    description: item.description ?? '',
    image: toDraftImage(item.image),
  }));

//* 저장 payload — 이름 없는 항목은 버린다(부고에 소제목만 뜨는 꼴을 막는다)
export const toAdditionalInfoPayload = (
  items: AdditionalInfoDraft[],
): FuneralHomeAdditionalInfo<string>[] =>
  items
    .filter((item) => item.name.trim().length > 0)
    .map((item) => ({
      ...(item._id ? { _id: item._id } : {}),
      name: item.name.trim(),
      description: item.description.trim() ? item.description : undefined,
      image: item.image?._id,
    }));
